import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ColorMapContextService } from '@shared/services/color-map-context.service';
import { CellData } from '@shared/services/image-feed/images-data-fetcher.service';
import { CellDataWithAnnotation } from '@shared/services/image-feed/sample-data-fetcher.service';

@Component({
    selector: 'image-feed-modal',
    templateUrl: './image-feed-modal.component.html',
    styleUrls: ['./image-feed-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageFeedModalComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            imageId: number
        },
        public colorMapService: ColorMapContextService
        ) {}
    
    isCellDataWithAnnotation(cellData: CellData): cellData is CellDataWithAnnotation {
        return "listCategories" in cellData;
    }
}
